module.exports = __webpack_public_path__ + "static/media/7c_website_logo_Gold_ke.09b87a7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/7c_website_logo_Gold_ke.jpg
// module id = 111
// module chunks = 0